import React from "react";
import { Select as MatSelect, MenuItem, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  select: {
    background: "#f3f4f8",
    border: 0,
    borderRadius: "0.1rem",
    minHeight: 50,
    fontSize: "1.1rem",
    fontFamily: "Ride",
    fontWeight: "400",
    textTransform: "none",
    paddingLeft: 10,
    paddingRight: 5,
  },
}));

const Select = (props) => {
  const classes = useStyles();
  // let style = `${classes.root}`;
  // style = `${style} ${classes[props.color]}`;

  return (
    <div>
      <MatSelect value={props.value} className={classes.select} onChange={props.onChange}>
        {props.options.map((value, index) => (
          <MenuItem key={index} value={value.value}>
            {value.title}
          </MenuItem>
        ))}
      </MatSelect>
    </div>
  );
};

export default Select;
